import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared/models/shared/error.model';
import { RedeliveryUserPreferenceComponentNameType, UserPreferenceComponentNameType, UserPreferenceResultType } from '@shared/types/user-preference.types';

const getInbondLayoutPreference = createAction(
  '[UserPreferenceActions] Get inbond storage layout preference data',
  props<{ componentName: UserPreferenceComponentNameType }>()
);
const getInbondLayoutPreferenceSuccess = createAction(
  '[UserPreferenceActions] Get inbond storage layout preference data Success',
  props<{ componentName: UserPreferenceComponentNameType; preferences: UserPreferenceResultType | undefined }>()
);
const getInbondLayoutPreferenceFail = createAction(
  '[UserPreferenceActions] Get inbond storage layout preference data Fail',
  props<{ componentName: UserPreferenceComponentNameType; errors: ErrorModel[] }>()
);

const updateInbondLayoutPreference = createAction(
  '[UserPreferenceActions] Update inbond storage layout preference data',
  props<{ componentName: UserPreferenceComponentNameType; preferences: UserPreferenceResultType }>()
);
const updateInbondLayoutPreferenceSuccess = createAction(
  '[UserPreferenceActions] Update inbond storage layout preference data Success',
  props<{ componentName: UserPreferenceComponentNameType; preferences: UserPreferenceResultType }>()
);
const updateInbondLayoutPreferenceFail = createAction(
  '[UserPreferenceActions] Update inbond storage layout preference data Fail',
  props<{ componentName: UserPreferenceComponentNameType; errors: ErrorModel[] }>()
);

const getRedeliveryLayoutPreference = createAction(
  '[UserPreferenceActions] Get redelivery storage layout preference data',
  props<{ componentName: RedeliveryUserPreferenceComponentNameType }>()
);
const getRedeliveryLayoutPreferenceSuccess = createAction(
  '[UserPreferenceActions] Get redelivery storage layout preference data Success',
  props<{ componentName: RedeliveryUserPreferenceComponentNameType; preferences: UserPreferenceResultType | undefined }>()
);
const getRedeliveryLayoutPreferenceFail = createAction(
  '[UserPreferenceActions] Get redelivery storage layout preference data Fail',
  props<{ componentName: RedeliveryUserPreferenceComponentNameType; errors: ErrorModel[] }>()
);

const updateRedeliveryLayoutPreference = createAction(
  '[UserPreferenceActions] Update redelivery storage layout preference data',
  props<{ componentName: RedeliveryUserPreferenceComponentNameType; preferences: UserPreferenceResultType }>()
);
const updateRedeliveryLayoutPreferenceSuccess = createAction(
  '[UserPreferenceActions] Update redelivery storage layout preference data Success',
  props<{ componentName: RedeliveryUserPreferenceComponentNameType; preferences: UserPreferenceResultType }>()
);
const updateRedeliveryLayoutPreferenceFail = createAction(
  '[UserPreferenceActions] Update redelivery storage layout preference data Fail',
  props<{ componentName: RedeliveryUserPreferenceComponentNameType; errors: ErrorModel[] }>()
);

export const UserPreferenceActions = {
  getInbondLayoutPreference,
  getInbondLayoutPreferenceSuccess,
  getInbondLayoutPreferenceFail,
  updateInbondLayoutPreference,
  updateInbondLayoutPreferenceSuccess,
  updateInbondLayoutPreferenceFail,
  getRedeliveryLayoutPreference,
  getRedeliveryLayoutPreferenceSuccess,
  getRedeliveryLayoutPreferenceFail,
  updateRedeliveryLayoutPreference,
  updateRedeliveryLayoutPreferenceSuccess,
  updateRedeliveryLayoutPreferenceFail,
};
